import { useQuery } from 'react-query';
import CompanyService from 'App/services/CompanyService';
import isOnLoginPage from 'App/utils/isOnLoginPage';

function useFetchDevFeatureFlagQuery() {
    const time = 10 * 60 * 1000;

    return useQuery(['featureFlags'], () => CompanyService.getDevFeatureFlags(), {
        cacheTime: time,
        staleTime: time,
        refetchInterval: () => {
            if (isOnLoginPage()) {
                return false;
            }
            return time;
        },
        refetchOnWindowFocus: false,
        enabled: !isOnLoginPage(),
    });
}

export default useFetchDevFeatureFlagQuery;
